import React from 'react'
import Home from './Home'

export default function OnlyOnApple() {
  return (
    <div>
      <h1>
        HIII
      </h1>
    </div>
  )
}
